import { render, staticRenderFns } from "./employeeInsuranceCompany.vue?vue&type=template&id=129864c2&scoped=true&"
import script from "./employeeInsuranceCompany.vue?vue&type=script&lang=js&"
export * from "./employeeInsuranceCompany.vue?vue&type=script&lang=js&"
import style0 from "./employeeInsuranceCompany.vue?vue&type=style&index=0&id=129864c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129864c2",
  null
  
)

export default component.exports